"use client";

import { useEffect } from "react";

const SESSION_KEY = "lokerdollar:streak-heartbeat-fired";

/**
 * Client-side daily heartbeat. Fires POST /api/me/heartbeat at most once per
 * tab per session (sessionStorage guard) so the server's date-change check
 * rolls the streak without a per-navigation D1 write.
 *
 * Passes the browser's resolved IANA tz so midnight rollover aligns with
 * the user's actual clock (e.g. a Jakarta user's streak continues if they
 * visit at 00:30 WIB, even though UTC is still 17:30 the day before).
 *
 * Rendered only for authenticated viewers (see {@link StreakHeartbeatIsland}
 * at mount sites). Fire-and-forget: 401 is swallowed so a stale client
 * session doesn't spam the console.
 */
export function StreakHeartbeat() {
	useEffect(() => {
		try {
			if (sessionStorage.getItem(SESSION_KEY) === "1") return;
		} catch {
			// blocked — fall through; server idempotency is our backstop.
		}

		let tz: string | undefined;
		try {
			tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
		} catch {
			tz = undefined;
		}

		fetch("/api/me/heartbeat", {
			method: "POST",
			keepalive: true,
			headers: { "content-type": "application/json" },
			body: JSON.stringify(tz ? { tz } : {}),
		}).catch(() => undefined);

		try {
			sessionStorage.setItem(SESSION_KEY, "1");
		} catch {
			// noop
		}
	}, []);

	return null;
}
